import React, { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import classes from './CustomImageSlider.module.scss';
import { MdArrowBackIos, MdArrowForwardIos } from 'react-icons/md';
import CustomImage from '../CustomImage/CustomImage';


const CustomImageSlider = ({ item }) => {
  const swiperRef = useRef(null);
  const [slideIndex, setSlideIndex] = useState(0);

  // Custom pagination dots component
  const renderCustomDots = () => {
    return (
      <div className={classes.Slider__CustomDots}>
        {item.options.map((_, index) => {
          const isActive = index === slideIndex;
          const isBeforeActive = index < slideIndex;
          const isAfterActive = index > slideIndex;
          const shift = 8;
          
          const style = {
            marginRight: isBeforeActive ? `${shift}px` : '0',
            marginLeft: isAfterActive ? `${shift}px` : '0',
          };
          
          return (
            <button
              key={index}
              className={`${classes.Slider__Dot} ${isActive ? classes['Slider__Dot--Active'] : ''}`}
              style={style}
              onClick={() => {
                setSlideIndex(index);
                swiperRef.current?.swiper?.slideTo(index);
              }}
              aria-label={`Go to slide ${index + 1}`}
            />
          );
        })}
      </div>
    );
  };

  return (
    <div className={classes.Slider}>
      <div className={`${classes.Slider__CardWrapper} ${item.bgColor}`}>
        <div className={classes.Slider__Card}>
          <Swiper
            ref={swiperRef}
            modules={[Pagination]}
            pagination={false} // Disable default pagination
            onSlideChange={(swiper) => setSlideIndex(swiper.activeIndex)}
            slidesPerView={1}
            spaceBetween={0}
            speed={500}
            allowTouchMove={true}
            touchRatio={1}
            threshold={10}
          >
            {item.options.map((slide, index) => (
              <SwiperSlide key={index} className={classes.Slider__Slide}>
                <CustomImage
                  title={slide.title}
                  images={[
                    {
                      media: '468',
                      src: item?.imagesMobile?.[index],
                    }
                  ]}
                  lazy={false}
                  defaultImg={item?.images[index]}
                />
              </SwiperSlide>
            ))}
          </Swiper>
          
          {/* Custom pagination dots */}
          {renderCustomDots()}
          
          {/* Navigation arrows */}
          {slideIndex > 0 && (
            <button
              className={`${classes.Slider__Arrow} ${classes['Slider__Arrow--Prev']}`}
              onClick={() => swiperRef.current?.swiper?.slidePrev()}
              aria-label="Previous slide"
            >
              <MdArrowBackIos size='1.2rem' />
            </button>
          )}
          {slideIndex < item.options.length - 1 && (
            <button
              className={`${classes.Slider__Arrow} ${classes['Slider__Arrow--Next']}`}
              onClick={() => swiperRef.current?.swiper?.slideNext()}
              aria-label="Next slide"
            >
              <MdArrowForwardIos size='1.2rem' />
            </button>
          )}
        </div>

        <div className={classes.Slider__Text}>
          <h4>{item.options[slideIndex].title}</h4>
          <p>{item.options[slideIndex].description}</p>
        </div>
      </div>
    </div>
  );
};

export default CustomImageSlider;
